/**
 * Чтение маркетинговых меток (UTM + партнёрский id `p`) для форм заявок.
 *
 * Захват в localStorage делает inline-скрипт в index.html — он срабатывает
 * до React на любой SSG-странице и переживает навигацию по SPA. Здесь —
 * только ЧТЕНИЕ сохранённых меток при отправке формы.
 *
 * TTL 30 дней (по ТЗ): метки старше — игнорируются. Фолбэк на текущий URL —
 * на случай если localStorage пуст, но метки прямо сейчас в адресной строке.
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'p']
const PREFIX = 'dnai_'
const TTL_MS = 30 * 24 * 60 * 60 * 1000

/**
 * Захват меток из URL в localStorage. Дублирует inline-скрипт index.html —
 * нужен для надёжности при client-side навигации внутри SPA (когда React Router
 * меняет URL с новыми метками без перезагрузки страницы).
 */
export function captureUtmToStorage(): void {
  if (typeof window === 'undefined') return
  try {
    const params = new URLSearchParams(window.location.search)
    let touched = false
    UTM_KEYS.forEach((k) => {
      const v = params.get(k)
      if (v) {
        localStorage.setItem(PREFIX + k, v)
        touched = true
      }
    })
    if (touched) localStorage.setItem(PREFIX + 'utm_ts', String(Date.now()))
    if (document.referrer && !localStorage.getItem(PREFIX + 'referrer')) {
      localStorage.setItem(PREFIX + 'referrer', document.referrer)
    }
  } catch {
    /* localStorage недоступен (приватный режим Safari) — не критично */
  }
}

/**
 * Прочитать сохранённые метки для отправки в форме.
 * Возвращает только непустые ключи + referrer.
 */
export function getStoredUtm(): Record<string, string> {
  const out: Record<string, string> = {}
  if (typeof window === 'undefined') return out

  try {
    const ts = Number(localStorage.getItem(PREFIX + 'utm_ts') || 0)
    const expired = ts > 0 && Date.now() - ts > TTL_MS
    if (!expired) {
      UTM_KEYS.forEach((k) => {
        const v = localStorage.getItem(PREFIX + k)
        if (v) out[k] = v
      })
    }
    const ref = localStorage.getItem(PREFIX + 'referrer')
    if (ref) out.referrer = ref
  } catch {
    /* ignore */
  }

  // Фолбэк: метки прямо в текущем URL (прямой заход без предыдущего захвата).
  try {
    const params = new URLSearchParams(window.location.search)
    UTM_KEYS.forEach((k) => {
      const v = params.get(k)
      if (v && !out[k]) out[k] = v
    })
  } catch {
    /* ignore */
  }

  return out
}
